import fetchApi from './api';
import {ApiResponse, LoginResponse, SearchPaging} from 'models/model';

export const SubjectSave = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Subject/Save', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const SubjectGetPaging = async (data: SearchPaging): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Subject/GetPaging', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const SubjectGet = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Subject/Get', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const SubjectDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Subject/Delete', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

